import css from './articleSearchTagField.module.css'
import { useState } from 'react'
import useHttpLoader from '../../../../../../../shared/hooks/useHttpLoader'
import { IFaqArticle, IFaqArticleSearchTag } from '../../../../faq.types'
import faqApi from 'screens/Admin/KnowleageBase/faq.api'
import faqEvents from '../../../../events/faq.events'
import CircleLoader from '../../../../../../../shared/Loaders/CircleLoader'
import TextField from '../../../../../../../shared/Forms/TextField'
import { ReactComponent as CloseIcon } from './../../../../../../../assets/icons/IconClose.svg'
import CreateArticleSearchTagModal from '../../../../pages/ArticleSearchTags/components/CreateArticleSearchTagModal'

interface IProps {
  article: IFaqArticle
}

const ArticleSearchTagField = (props: IProps) => {
  const { loading: attachTagLoading, wait: waitAttachingTag } = useHttpLoader()
  const { loading: deleteTagLoading, wait: waitDeletingTag } = useHttpLoader()
  const [createModalOpen, setCreateModalOpen] = useState(false)

  const createTagAction = (action: 'delete' | 'attach') => (contextTag: IFaqArticleSearchTag) => {
    const waitFn = action === 'delete' ? waitDeletingTag : waitAttachingTag

    let searchTags = []
    const searchTagsIds = props.article.searchTags.map((c) => c.tag.id)

    if (action === 'delete') {
      searchTags = searchTagsIds.filter((id) => id !== contextTag.id)
    } else {
      searchTags = [...searchTagsIds, contextTag.id]
    }

    waitFn(faqApi.updateArticle(props.article.id, { ...props.article, searchTags }), (resp) => {
      if (resp.status === 'success') {
        faqEvents.articleUpdated(resp.body, props.article.id)
      }
    })
  }

  const renderLoader = () => (
    <CircleLoader
      style={{ width: 10, height: 10, marginLeft: 6 }}
      ringStyle={{ width: 10, height: 10, margin: 0, borderWidth: 1 }}
      color='var(--text-primary)'
    />
  )

  return (
    <TextField header='Поисковые теги' contentStyle={{ display: 'flex', flexWrap: 'wrap', gap: '0.5em' }}>
      {props.article.searchTags.length > 0
        ? props.article.searchTags.map((c) => (
            <div className={css.tag}>
              {c.tag.name}
              {!deleteTagLoading && (
                <CloseIcon
                  className={css.closeIcon}
                  onClick={() => createTagAction('delete')(c.tag as IFaqArticleSearchTag)}
                />
              )}
              {deleteTagLoading && renderLoader()}
            </div>
          ))
        : '-'}
      <div className={css.tag} onClick={() => setCreateModalOpen(true)} data-create='true'>
        {attachTagLoading ? renderLoader() : '+'}
      </div>
      {createModalOpen && (
        <CreateArticleSearchTagModal onClose={() => setCreateModalOpen(false)} onSuccess={createTagAction('attach')} />
      )}
    </TextField>
  )
}

export default ArticleSearchTagField
